import { Heading, Modal, Button } from '@simplywallst/ui-core/next';

interface Props {
  onClose: () => void;
}

export const ReturnsInformationModal = ({ onClose }: Props) => (
  <Modal
    title="How returns are calculated"
    isOpen={true}
    onClose={onClose}
    className="grid max-w-[700px] grid-rows-[max-content_1fr] md:h-auto"
  >
    <Modal.Body>
      <p className="m-x0 mb-x2 text-xs">
        These calculations apply to both each holding and your overall
        portfolio.
      </p>
      <p className="m-x0 mb-x2 text-xs">
        All <strong>return percentages</strong> are based on your{' '}
        <strong>Cumulative Capital Invested</strong> (the total amount you've
        invested over time).
      </p>
      <Heading as="h3" size="small" className="mb-x0_5">
        Percentage returns
      </Heading>
      <ul className="mb-x1 list-disc text-xs [&>li]:my-x0_5 [&>li]:ml-x3">
        <li>
          <strong>Total Returns %</strong> = Total Return $ / Cumulative Capital
          Invested
        </li>
        <li>
          <strong>Unrealised Returns %</strong> = Unrealised Gain/Loss $ /
          Cumulative Capital Invested Invested
        </li>
        <li>
          <strong>Realised Returns %</strong> = Realised Gain/Loss $ /
          Cumulative Capital Invested
        </li>
        <li>
          <strong>Dividend Returns %</strong> = Dividends Received $ /
          Cumulative Capital Invested
        </li>
        <li>
          <strong>Currency Returns %</strong> = Currency Gain/Loss $ /
          Cumulative Capital Invested
        </li>
      </ul>
      <Heading as="h3" size="small" className="mb-x0_5 mt-x1">
        Cash returns
      </Heading>
      <ul className="mb-x1 list-disc text-xs [&>li]:my-x0_5 [&>li]:ml-x3">
        <li>
          <strong>Unrealised Return $</strong> = (Current Price – Average Buy
          Price) × Shares Held
        </li>
        <li>
          <strong>Realised Return $</strong> = Proceeds from Sold Shares – Their
          Cost Basis
        </li>
        <li>
          <strong>Dividend Return $</strong> = Total Dividends Received
        </li>
        <li>
          <strong>Currency Return $</strong> = Impact of exchange rate changes
          on your returns
        </li>
        <li>
          <strong>Total Return $</strong> = Unrealised + Realised + Dividends +
          Currency
        </li>
      </ul>
      <p className="m-x0 my-x1 text-xs">
        These breakdowns help you understand where your returns are coming from
        — growth, dividends, currency effects, or realised profits.
      </p>
      <Modal.Actions>
        <Button
          variant="secondary"
          href="https://support.simplywall.st/hc/en-us/articles/9423775242383-Understanding-the-Portfolio-Returns-Analysis-Calculations#h_01JMGT2TBADM8EBF4SVJ9HDMEQ"
          target="_blank"
        >
          Learn more
        </Button>
        <Button variant="primary" onClick={onClose}>
          Close
        </Button>
      </Modal.Actions>
    </Modal.Body>
  </Modal>
);
